import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import ChartIcon from 'components/icons/chartIcon';
import { useTranslation, Trans } from 'react-i18next';

const useStyles = makeStyles({
    root: {
        color: "gray",
        minHeight: "200px",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column"
    },
    item: {
        alignSelf: "center",

    }
});

export default function EmptyChart(props) {
    const { ...rest } = props;
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div {...rest} className={classes.root}>
            <ChartIcon />
            <div className={classes.item}>{t("graphNoDataMessage")}</div>
        </div>
    );
}
